/* ------------------------------------------------------------------
 * Federica Oliva — nastro di card che scorre da solo
 *
 * Trasforma un contenitore in un carosello continuo: le card sfilano
 * senza interruzioni, quella al centro è a fuoco, le laterali arretrano.
 * Si ferma al passaggio del mouse e mentre si trascina col dito.
 * ------------------------------------------------------------------ */

(function () {
  var HOSTS = '[data-fo-marquee]';
  var DEFAULT_SPEED = 26; /* px al secondo */

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function setup(host) {
    if (host.getAttribute('data-fo-marquee-ready')) return;

    var cells = Array.prototype.slice.call(host.children);
    if (cells.length < 2) return;

    host.setAttribute('data-fo-marquee-ready', '1');
    host.classList.add('fo-marquee');

    var track = document.createElement('div');
    track.className = 'fo-marquee__track';
    cells.forEach(function (cell) {
      cell.classList.add('fo-marquee__cell');
      track.appendChild(cell);
    });
    host.appendChild(track);

    var speed = parseFloat(host.getAttribute('data-fo-marquee-speed')) || DEFAULT_SPEED;
    var setWidth = 0;
    var all = cells.slice();
    var geo = [];
    var offset = 0;
    var paused = false;
    var visible = false;
    var dragging = false;
    var moved = 0;
    var pointerId = null;
    var startX = 0;
    var startY = 0;
    var axis = '';
    var startOffset = 0;
    var lastTime = 0;
    var raf = null;
    var depth = host.getAttribute('data-fo-marquee-depth') || '';
    var stage = depth === 'stage';
    /* "even": nastro a passo costante, card sfalsate in verticale. Nessuna
       card a fuoco: serve a distinguere una sezione dall'altra. */
    var even = depth === 'even';
    var dir = host.getAttribute('data-fo-marquee-dir') === 'rtl' ? -1 : 1;
    var entered = false;
    var shading = false;

    if (stage) host.classList.add('fo-marquee--stage');
    if (even) {
      host.classList.add('fo-marquee--even');
      /* la classe va sugli originali prima delle copie, così lo sfalsamento
         resta lo stesso anche dopo il riavvolgimento */
      cells.forEach(function (cell, i) {
        if (i % 2) cell.classList.add('fo-marquee__cell--low');
      });
    }
    /* Le card partono nascoste da subito: se lo stato iniziale arrivasse solo
       quando la sezione entra in campo, si vedrebbe lo scatto da piena a zero. */
    host.classList.add('is-entering');

    /* Le copie servono solo a chiudere l'anello: fuori dal flusso di lettura
       e non raggiungibili da tastiera. */
    function clone() {
      var copy = document.createDocumentFragment();
      cells.forEach(function (cell) {
        var c = cell.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('data-fo-marquee-clone', '1');
        Array.prototype.forEach.call(c.querySelectorAll('a, button, input, select'), function (el) {
          el.setAttribute('tabindex', '-1');
        });
        all.push(c);
        copy.appendChild(c);
      });
      track.appendChild(copy);
    }

    /* Su schermo largo le card crescono con la larghezza e la sezione supera
       l'altezza della finestra: lo scorrimento per sezioni non riesce più ad
       agganciarla e ci si ferma a metà. Qui la card viene rimpicciolita finché
       la sezione sta in una schermata, intestazione compresa. */
    function fitViewport() {
      if (!window.matchMedia('(min-width: 1025px)').matches) {
        host.style.removeProperty('--fo-marquee-card');
        return;
      }

      var section = host.closest ? host.closest('.shopify-section') : null;
      if (!section) return;

      var bar = document.getElementById('site-control');
      var head = bar ? bar.getBoundingClientRect().height : 0;
      if (head > window.innerHeight * 0.3) head = 0;
      var room = window.innerHeight - head;

      /* si riparte dalla misura naturale: altrimenti la sezione risulterebbe
         a posto solo grazie al ritocco della volta prima */
      host.style.removeProperty('--fo-marquee-card');

      for (var pass = 0; pass < 5; pass++) {
        /* misure di layout, non geometriche: le card sono trasformate */
        var cw = cells[0].offsetWidth;
        var ch = cells[0].offsetHeight;
        if (!cw || !ch) return;
        var over = section.offsetHeight - room;
        if (over <= 1) return;
        /* la didascalia non si accorcia con la foto: si toglie un po' di più
           per non doverci tornare sopra a ogni passata */
        var target = (ch - over - 2) * (cw / ch);
        /* su finestre basse il minimo di prima teneva la sezione fuori misura:
           meglio una card piccola che un secondo gesto per finire la sezione */
        if (target < 140) target = 140;
        host.style.setProperty('--fo-marquee-card', Math.round(target) + 'px');
        if (target <= 140) return;
      }
    }

    function measure() {
      fitViewport();

      var first = cells[0];
      /* Con lo sfalsamento a scacchiera e un numero dispari di card il giro si
         chiuderebbe con una card alta al posto di una bassa: in quel caso
         l'anello vale due set. */
      var period = even && cells.length % 2 ? 2 : 1;

      /* Una copia completa ci vuole sempre: è lei a chiudere l'anello. Senza,
         il riavvolgimento avviene solo dopo l'ultima card e nel frattempo la
         sezione resta vuota. */
      while (all.length < cells.length * (period + 1)) clone();

      setWidth = all[cells.length * period].offsetLeft - first.offsetLeft;

      /* Oltre all'anello serve una schermata di scorta: è quella che copre il
         salto all'indietro quando l'offset torna a zero. Si misura dall'ultima
         card, non da scrollWidth: il nastro deborda da un contenitore che non
         scorre e i browser non concordano su quel valore. */
      function contentWidth() {
        var last = all[all.length - 1];
        return last.offsetLeft + last.offsetWidth - first.offsetLeft;
      }

      var guard = 0;
      while (setWidth > 0 && contentWidth() < setWidth + host.clientWidth && guard < 8) {
        clone();
        guard += 1;
      }

      geo = all.map(function (cell) {
        return { el: cell, mid: cell.offsetLeft + cell.offsetWidth / 2, w: cell.offsetWidth };
      });
    }

    /* Profondità: la card al centro è piena, le altre arretrano e sbiadiscono.
       In modalità "stage" ruotano anche sull'asse verticale, come un ventaglio
       di fotografie appoggiate una dietro l'altra.
       Si calcola dalla geometria in cache, senza rileggere il layout ogni frame. */
    function shade() {
      if (!shading || even) return;
      var mid = host.clientWidth / 2;
      var reach = host.clientWidth * 0.5 || 1;
      for (var i = 0; i < geo.length; i++) {
        var g = geo[i];
        var x = g.mid - offset;
        if (x < -g.w || x > host.clientWidth + g.w) {
          if (g.el.style.transform) g.el.style.transform = '';
          continue;
        }
        var signed = Math.max(-1, Math.min(1, (x - mid) / reach));
        var d = Math.abs(signed);

        if (stage) {
          g.el.style.transform =
            'translate3d(0,' +
            (d * 8).toFixed(2) +
            'px,' +
            (-d * 90).toFixed(1) +
            'px) rotateY(' +
            (-signed * 14).toFixed(2) +
            'deg) scale(' +
            (1 - 0.05 * d).toFixed(4) +
            ')';
          g.el.style.opacity = (1 - 0.42 * d).toFixed(3);
          g.el.style.zIndex = String(100 - Math.round(d * 60));
        } else {
          g.el.style.transform =
            'translate3d(0,' + (-7 * (1 - d)).toFixed(2) + 'px,0) scale(' + (1 - 0.07 * d).toFixed(4) + ')';
          g.el.style.opacity = (1 - 0.4 * d).toFixed(3);
        }
      }
    }

    /* Ingresso: le card salgono una dopo l'altra, poi il nastro parte. Finché
       dura, la profondità resta ferma: due transform in gara sullo stesso
       elemento darebbero uno scatto. */
    function enter() {
      if (entered) return;
      entered = true;

      var step = 0;
      for (var i = 0; i < cells.length; i++) {
        cells[i].style.setProperty('--fo-in-index', String(Math.min(i, 6)));
        step = Math.min(i, 6);
      }

      void host.offsetWidth;
      host.classList.add('is-entered');

      window.setTimeout(function () {
        host.classList.remove('is-entering', 'is-entered');
        /* transizione breve per entrare nella prospettiva senza salto */
        host.classList.add('is-settling');
        shading = true;
        start();
        window.setTimeout(function () {
          host.classList.remove('is-settling');
        }, 700);
      }, 420 + step * 110 + 700);
    }

    function frame(t) {
      var dt = lastTime ? Math.min(64, t - lastTime) : 16;
      lastTime = t;

      /* Il nastro scorre anche con "riduci animazioni" di sistema attivo:
         è il contenuto della sezione, non una decorazione. Si ferma comunque
         al passaggio del mouse, al fuoco da tastiera e fuori dal viewport. */
      if (!paused && !dragging) {
        offset += (dir * speed * dt) / 1000;
      }
      if (setWidth > 0) {
        while (offset >= setWidth) offset -= setWidth;
        while (offset < 0) offset += setWidth;
      }

      track.style.transform = 'translate3d(' + -offset.toFixed(2) + 'px,0,0)';
      shade();
      raf = window.requestAnimationFrame(frame);
    }

    function start() {
      if (raf) return;
      lastTime = 0;
      raf = window.requestAnimationFrame(frame);
    }

    function stop() {
      if (!raf) return;
      window.cancelAnimationFrame(raf);
      raf = null;
    }

    function onEnter() {
      paused = true;
    }

    function onLeave() {
      paused = false;
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      /* col dito il verso si decide al primo movimento: finché non è chiaro
         che è orizzontale il nastro non si muove e la pagina scorre */
      axis = e.pointerType === 'mouse' ? 'x' : '';
      moved = 0;
      pointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      startOffset = offset;
      host.classList.add('is-dragging');
    }

    function onPointerMove(e) {
      if (!dragging || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if (!axis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          /* è uno scorrimento della pagina: il nastro si tira indietro */
          dragging = false;
          pointerId = null;
          host.classList.remove('is-dragging');
          return;
        }
        axis = 'x';
      }

      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      offset = startOffset - dx;
      /* oltre la soglia è un trascinamento, non un tocco sulla card */
      if (moved > 6) host.classList.add('is-swiping');
    }

    function onPointerUp(e) {
      if (!dragging || (pointerId !== null && e.pointerId !== pointerId)) return;
      dragging = false;
      axis = '';
      pointerId = null;
      host.classList.remove('is-dragging');
      window.setTimeout(function () {
        host.classList.remove('is-swiping');
      }, 0);
    }

    /* Col puntatore sopra il nastro si ferma: da lì lo si muove a mano, col
       trascinamento oppure con la rotella orizzontale (o maiuscolo + rotella).
       Lo scorrimento verticale della pagina resta al suo posto. */
    function onWheel(e) {
      /* Una rotella verticale, anche se il trackpad aggiunge un po' di asse X,
         deve far scorrere la pagina. Il nastro prende solo il gesto chiaro
         orizzontale, o maiuscolo + rotella. */
      var horizontal = e.shiftKey || Math.abs(e.deltaX) > Math.abs(e.deltaY) * 1.6;
      if (!horizontal) return;
      var dx = e.shiftKey ? e.deltaY : e.deltaX;
      if (!dx) return;
      e.preventDefault();
      offset += dx;
      moved = 0;
    }

    function onClick(e) {
      if (moved > 6) {
        e.preventDefault();
        e.stopPropagation();
        moved = 0;
      }
    }

    /* In senso opposto si parte da un giro intero: l'offset può così scendere
       fino a zero senza il salto iniziale all'indietro, e la posizione è la
       stessa di partenza perché il nastro si ripete a ogni giro. */
    function rewind() {
      offset = dir < 0 ? setWidth : 0;
    }

    var resizeTimer = null;
    function onResize() {
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        offset = 0;
        measure();
        rewind();
      }, 180);
    }

    measure();
    rewind();
    /* le immagini prodotto arrivano dopo: senza una seconda misura la lunghezza
       dell'anello resta quella dei placeholder e il giro salta */
    window.setTimeout(measure, 600);
    window.setTimeout(measure, 2000);
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(measure).catch(function () {});
    }

    /* le foto arrivano a schermata già inquadrata: quando entrano cambiano
       l'altezza della card, e con lei quella della sezione */
    Array.prototype.forEach.call(host.querySelectorAll('img'), function (img) {
      if (img.complete) return;
      img.addEventListener('load', onResize, { once: true });
    });

    host.addEventListener('mouseenter', onEnter);
    host.addEventListener('mouseleave', onLeave);
    host.addEventListener('focusin', onEnter);
    host.addEventListener('focusout', onLeave);
    host.addEventListener('pointerdown', onPointerDown);
    host.addEventListener('pointermove', onPointerMove);
    host.addEventListener('pointerup', onPointerUp);
    host.addEventListener('pointercancel', onPointerUp);
    host.addEventListener('wheel', onWheel, { passive: false });
    host.addEventListener('click', onClick, true);
    window.addEventListener('resize', onResize, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else if (visible) start();
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          visible = entries[0].isIntersecting;
          if (!visible) return stop();
          onResize();
          if (!entered) enter();
          else if (shading) start();
        },
        { rootMargin: '0px 0px -12% 0px' }
      );
      io.observe(host);
      /* rete di sicurezza: se l'osservatore non scatta mai (sezione in un
         contenitore nascosto, browser bizzarri) le card non restano invisibili */
      window.setTimeout(enter, 4000);
    } else {
      visible = true;
      enter();
    }
  }

  ready(function () {
    Array.prototype.forEach.call(document.querySelectorAll(HOSTS), setup);
  });

  document.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call((e.target || document).querySelectorAll(HOSTS), setup);
  });
})();
